export const identifierLooksLikeEmail = (value) =>
  /@/.test(String(value || "").trim());

export const getAccountId = (account) => account?.id || account?.userId || "";

export const getAccountUserType = (account) =>
  String(account?.userType || "").toLowerCase();

export const isHashedPassword = (value) => {
  const password = String(value || "");
  return (
    password.startsWith("$2a$") ||
    password.startsWith("$2b$") ||
    password.startsWith("$2y$") ||
    password.startsWith("$argon2")
  );
};

export const canComparePasswordLocally = (remotePassword) => {
  if (remotePassword == null || remotePassword === "") {
    return false;
  }
  if (typeof remotePassword === "boolean") {
    return false;
  }
  if (isHashedPassword(remotePassword)) {
    return false;
  }
  return true;
};

export const accountNeedsPassword = (account) => {
  if (!account || typeof account !== "object") {
    return false;
  }

  const userType = getAccountUserType(account);
  const remotePassword = account.password;

  if (userType === "vendor") {
    return remotePassword !== "" && remotePassword != null;
  }

  return Boolean(remotePassword);
};

export const normalizeLoginResponse = (response) => {
  if (response == null) {
    return null;
  }

  if (Array.isArray(response)) {
    return normalizeLoginResponse(response[0]);
  }

  if (typeof response !== "object") {
    return null;
  }

  const nestedCandidates = [response.user, response.account, response.data];
  let account = response;

  for (const nested of nestedCandidates) {
    if (
      nested &&
      typeof nested === "object" &&
      !Array.isArray(nested) &&
      (nested.id || nested.userId || nested.userType || nested.email)
    ) {
      account = nested;
      break;
    }
  }

  const accessToken =
    account.accessToken ||
    account.token ||
    account.access_token ||
    response.accessToken ||
    response.token ||
    response.access_token;

  return {
    ...account,
    accessToken,
  };
};

export const loginErrorMessage = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const serverMessage =
    (typeof data === "string" && data) ||
    data?.message ||
    data?.error ||
    data?.msg;

  if (status === 401 || status === 403) {
    return typeof serverMessage === "string" && serverMessage.trim()
      ? serverMessage
      : "password incorrect";
  }

  if (status === 404) {
    return typeof serverMessage === "string" && serverMessage.trim()
      ? serverMessage
      : "account not found";
  }

  if (typeof serverMessage === "string" && serverMessage.trim()) {
    return serverMessage;
  }

  return "Unable to sign in. Please try again.";
};
